import { FC, useEffect, useRef } from 'react'
import { IconButton } from '@cargomart/ui'
import IconModalClose from 'assets/modal-close.svg?react'
import cn from 'classnames'
import { ClickOutside } from 'components/helpers/ClickOutside'
import { useActions } from 'hooks/useActions'

import { MobileMenu } from '../MobileMenu'
import { SidebarProps } from './types'

import s from './Sidebar.module.less'

export const Sidebar: FC<SidebarProps> = () => {
  const isRender = useRef(false)

  const { closeMobileSidebar } = useActions()

  const handleClose = () => {
    closeMobileSidebar()
  }

  useEffect(() => {
    isRender.current = true

    return () => {
      isRender.current = false
    }
  }, [])

  return (
    <ClickOutside
      className={cn(s.Sidebar, 'rounded-br-xl rounded-tr-xl')}
      data-component="modal"
      onClickOutside={handleClose}
    >
      <div className="m-2 mb-4">
        <IconButton onClick={handleClose}>
          <IconModalClose size="sm" />
        </IconButton>
      </div>
      <div className={s.content}>
        <MobileMenu />
      </div>
    </ClickOutside>
  )
}
